import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
import { ProtectedRoleTecnical } from "../hooks/roles/ProtectedRoleTecnical";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const NuevoCasoSimplificado = React.lazy(
  () => import("../screean/services/nuevo-caso-simplificado")
);
export function nuevoCasoSimplificado() {
  return (
    <Route
      path="/nuevo-caso-simplificado"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <ProtectedRoleTecnical>
              <LazySuspense>
                <NuevoCasoSimplificado />
              </LazySuspense>
            </ProtectedRoleTecnical>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
